'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/6/25.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductPreviewHeader = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProductPreviewHeader, _Component);

  function ProductPreviewHeader() {
    (0, _classCallCheck3.default)(this, ProductPreviewHeader);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ProductPreviewHeader).call(this));
  }

  (0, _createClass3.default)(ProductPreviewHeader, [{
    key: 'onPolicyChange',
    value: function onPolicyChange(val) {
      var policyChange = this.props.policyChange;

      if (policyChange) {
        policyChange(val);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ProductPreviewHeader.scss');
      var _props = this.props;
      var data = _props.data;
      var page = _props.page;
      /*  let options = [];
       if (data.policyList instanceof Array) {
       options = data.policyList.map((currentPolicy)=> {
       return <option key={currentPolicy.value} value={currentPolicy.value}>{currentPolicy.label}</option>;
       });
       }
       options.splice(0, 0, <option key="null" value=""> -- 不使用优惠 -- </option>);*/

      var styleBg = '';
      if (page === 'OrderPreview') {
        styleBg = styles.bg;
      }
      return _react2.default.createElement(
        'div',
        { className: styles.component + '' + styleBg },
        _react2.default.createElement(
          'div',
          { className: styles.col, style: { marginLeft: '10%' } },
          _react2.default.createElement(
            'span',
            null,
            '艺品数量:  '
          ),
          _react2.default.createElement(
            'div',
            { className: styles.colDiv },
            data.number
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.col },
          _react2.default.createElement(
            'span',
            null,
            '艺品金额:  '
          ),
          _react2.default.createElement(
            'div',
            { className: styles.colDiv },
            data.money
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.col },
          _react2.default.createElement(
            'span',
            null,
            '包装费用:  '
          ),
          _react2.default.createElement(
            'div',
            { className: styles.colDiv },
            data.packagingCost
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.col },
          _react2.default.createElement(
            'span',
            null,
            '服务费用:  '
          ),
          _react2.default.createElement(
            'div',
            { className: styles.colDiv },
            data.servicesCost
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.col, style: { marginLeft: '10%' } },
          _react2.default.createElement(
            'span',
            null,
            '定制费用:  '
          ),
          _react2.default.createElement(
            'div',
            { className: styles.colDiv },
            data.customCost
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.col },
          _react2.default.createElement(
            'span',
            null,
            '购买金额:  '
          ),
          _react2.default.createElement(
            'div',
            { className: styles.colDiv },
            data.buyMoney
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.col },
          _react2.default.createElement(
            'span',
            null,
            '优惠金额:  '
          ),
          _react2.default.createElement(
            'div',
            { className: styles.colDiv },
            data.discount
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.col },
          _react2.default.createElement(
            'span',
            null,
            '结算金额:  '
          ),
          _react2.default.createElement(
            'div',
            { className: styles.colDiv, style: { color: '#ff0000' } },
            data.sumMoney
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ProductPreviewHeader;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  policyChange: _react.PropTypes.func,
  page: _react.PropTypes.string
}, _temp);
exports.default = ProductPreviewHeader;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ProductPreviewHeader/ProductPreviewHeader.js
 ** module id = 1411
 ** module chunks = 0
 **/